import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config";



const initialState = {
    data: null,
    loading: false,
    error: null,
    leave: null
    // interviewResponse: null,
}



export const applyLeave = createAsyncThunk(
    "applyLeave",
    async (body) => {

        try {
            const res = await instance.post("/crm/leave/apply-leave", body)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)
// export const addLeave = createAsyncThunk(
//     "addLeave",

//         async (body, { rejectWithValue }) => {
//             const formData = new FormData();
//             formData.append("employee_name", body.employee_name);
//             formData.append("from_date", body.from_date);
//             formData.append("to_date", body.to_date);
//             formData.append("leave_type", body.leave_type);
//             formData.append("leave_description", body.leave_description);

//             try {
//                 const response = await instance.post("/crm/leave/apply-leave-hr", formData);
//                 return response?.data
//             } catch (error) {
//                 return rejectWithValue(error.response)
//             }
//         }

// )

export const addLeave = createAsyncThunk(
    "addLeave",
    async (body, { rejectWithValue }) => {


        try {
            const res = await instance.post(`/crm/leave/apply-leave-hr?id=${body.lv_employee_id}`, body);
            return res.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: "Something went wrong" });
        }
    }
);


export const leaveList = createAsyncThunk(
    "leaveList",
    async () => {

        try {
            const res = await instance.get("/crm/leave/fetch-leave")
            return res?.data
        } catch (error) {
            throw error
        }
    }
)



export const LeaveStatusUpdate = createAsyncThunk(
    "LeaveStatusUpdate",
    async (data) => {
        try {

            const response = await instance.post(`/crm/leave/update-leave-status?id=${data.lv_id}`, data)
            return response?.data

        } catch (error) {
            throw error;
        }
    }
);

export const removeLeave = createAsyncThunk(
    "removeLeave",
    async (id) => {

        try {
            const response = await instance.post(`/crm/leave/delete-leave?id=${id}`);
            return response.data
        } catch (error) {

        }
    }
)


export const LeaveSlice = createSlice({
    name: "LeaveSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(applyLeave.pending, (state) => {
            state.loading = true;
            // state.interviewResponse = null;
            state.data = null;
        });
        builder.addCase(applyLeave.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(applyLeave.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(addLeave.pending, (state) => {
            state.loading = true;

            state.data = null;
        });
        builder.addCase(addLeave.fulfilled, (state, action) => {

            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(addLeave.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(removeLeave.pending, (state) => {
            state.loading = true;

            state.data = null;
        });
        builder.addCase(removeLeave.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(removeLeave.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(leaveList.pending, (state) => {
            state.loading = true;

        });
        builder.addCase(leaveList.fulfilled, (state, action) => {
            state.loading = false;
            state.leave = action.payload;
        });
        builder.addCase(leaveList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

    }
})

export default LeaveSlice.reducer;